
const common = {
  // Navbar
  "nav.philosophy": "Philosophy",
  "nav.products": "Products",
  "nav.buy": "Buy",
  "nav.contact": "Contact",
  "nav.more": "More",
  "nav.medicalOrigin": "Medical Origin",
  "nav.bodyAesthetics": "Body Aesthetics",
  "nav.scienceDesign": "Science & Design",
  "nav.quality": "Quality",
  "nav.trust": "Trust",
  "nav.journal": "Journal",

  // Hero Section
  "hero.title1": "In Balance",
  "hero.title2": "with the Body.",
  "hero.cta": "Discover Philosophy",
  "hero.description": "A German medical approach to body alignment, posture, and daily health care.",
  "hero.founded": "Founded in Germany, 2018",

  // Brand Philosophy Section
  "brand.label": "(Brand Philosophy)",
  "brand.title1": "True Body Aesthetics",
  "brand.title2": "Is Not Aggressive Change.",
  "brand.desc1": "DR. MAGICAL believes that true body aesthetics comes from understanding structure, posture, and daily habits — not from radical interventions.",
  "brand.desc2": "Through non-surgical, physical correction methods, we support the body's natural alignment and long-term balance.",
  "brand.learnMore": "Learn More",

  // German Medical Origin Section
  "medical.title": "Medical Insight, German Precision.",
  "medical.subtitle": "Rooted in medical rigor and engineering discipline",
  "medical.origin": "Medical Origin, Germany",
  "medical.precision": "Engineering Precision",
  "medical.structure": "Product Structure & Design",

  // Non-Invasive Section
  "noninvasive.title": "A Non-Invasive Approach to Body Alignment",
  "noninvasive.subtitle": "Our products work with the body, not against it — restoring balance through consistency rather than intensity.",
  "noninvasive.feature1.title": "No Surgery. No Dependency.",
  "noninvasive.feature1.desc": "Safe and natural methods that respect your body's integrity.",
  "noninvasive.feature2.title": "Gentle Physical Guidance",
  "noninvasive.feature2.desc": "No forced correction, but supportive alignment over time.",
  "noninvasive.feature3.title": "Designed for Long-Term Use",
  "noninvasive.feature3.desc": "Sustainable solutions that become part of your daily routine.",

  // Products Section
  "products.title": "Daily Care Solutions",
  "products.subtitle": "Designed for comfort, precision, and discretion",
  "products.viewAll": "View All Products",
  "products.viewDetails": "View Details",
  "products.product1.name": "Mouth Breathing Correction",
  "products.product1.desc": "For improved breathing patterns during sleep",
  "products.product2.name": "Nasal Support & Airflow",
  "products.product2.desc": "Gentle support for optimal nasal breathing",
  "products.product3.name": "Sleep & Noise Management",
  "products.product3.desc": "For restful sleep and noise reduction",

  // Design Section
  "design.title1": "Designed for Comfort,",
  "design.title2": "Precision and Discretion",
  "design.desc1": "From material selection to structural design, every DR. MAGICAL product is developed to balance functionality with wearing comfort.",
  "design.desc2": "Invisible when worn. Effortless in daily life.",

  // Trust Section
  "trust.title1": "Official Channels.",
  "trust.title2": "Long-Term Trust.",
  "trust.cta": "Where to Buy",
  "trust.description": "We reach consumers worldwide and change the lives of hundreds of millions of consumers. Since market entry, DR. MAGICAL has partnered with leading platforms like Amazon, Wish, Noon, Tmall Global, Alibaba Health, JD Supermarket, and Tmall Supermarket.",

  // Customer Stories Section
  "stories.title": "Supporting the Body Quietly, Over Years.",
  "stories.subtitle": "True quality is not complexity — it is respect for the body and long-term companionship. DR. MAGICAL strives to become an essential part of premium family health management worldwide.",
  "stories.successStory": "Success Story",
  "stories.highlight.title": "\"My Family Finally Sleeps Through the Night\"",
  "stories.highlight.desc": "The Schneider family from Frankfurt shares their experience: After years of sleep problems due to mouth breathing, the whole family found restful sleep again with DR. MAGICAL. A story about patience, trust, and sustainable change.",
  "stories.readStory": "Read Story",
  "stories.viewAll": "All Customer Stories",
  "stories.review1": "\"After just 3 weeks of using the mouth breathing correction, I sleep much better. My partner noticed the difference immediately - no more snoring!\"",
  "stories.review1.name": "Sabine M.",
  "stories.review1.location": "Munich, Germany",
  "stories.review2": "\"As a doctor, I appreciate DR. MAGICAL's scientific approach. The nasal support has significantly improved my chronic breathing problems.\"",
  "stories.review2.name": "Dr. Thomas K.",
  "stories.review2.location": "Berlin, Germany",
  "stories.review3": "\"Finally a solution that really works! The quality is excellent and the wearing comfort surprisingly good. Highly recommended.\"",
  "stories.review3.name": "Lisa W.",
  "stories.review3.location": "Hamburg, Germany",

  // Footer
  "footer.salesChannels": "Sales Channels",
  "footer.contact": "Contact",
  "footer.follow": "Follow",
  "footer.copyright": "© 2018-2026 DR. MAGICAL. All rights reserved.",
  "footer.privacy": "Privacy",
  "footer.terms": "Terms of Service",

  // Cookie Banner
  "cookie.title": "We Use Cookies",
  "cookie.description": "We use cookies and similar technologies to improve your experience, analyze traffic, and personalize content. According to EU GDPR, we need your consent for non-essential cookies.",
  "cookie.settings": "Settings",
  "cookie.onlyNecessary": "Only Necessary",
  "cookie.acceptAll": "Accept All",
  "cookie.settingsTitle": "Cookie Settings",
  "cookie.necessary": "Necessary Cookies",
  "cookie.necessaryRequired": "Required",
  "cookie.necessaryDesc": "These cookies are essential for basic website functions and cannot be disabled.",
  "cookie.analytics": "Analytics Cookies",
  "cookie.analyticsDesc": "Help us understand how visitors interact with the website to improve user experience.",
  "cookie.marketing": "Marketing Cookies",
  "cookie.marketingDesc": "Used to show visitors relevant advertising and marketing campaigns.",
  "cookie.functional": "Functional Cookies",
  "cookie.functionalDesc": "Enable advanced features and personalization, such as videos and live chats.",
  "cookie.validFrom": "Valid from: January 1, 2026 | According to EU GDPR",
  "cookie.rejectAll": "Reject All",
  "cookie.saveSettings": "Save Settings",

  // Loading
  "loading": "Loading...",

  // Language
  "language": "Language",
  "language.de": "Deutsch",
  "language.en": "English",

  // Products Page
  "productsPage.title": "Daily Care Solutions",
  "productsPage.subtitle": "Non-invasive products for long-term body alignment and health management",
  "productsPage.category.mouthCare": "Mouth Breathing Care",
  "productsPage.category.mouthCare.desc": "Gentle solutions to support nasal breathing and correct mouth posture during sleep and daily activities.",
  "productsPage.category.nasalCare": "Nasal Care",
  "productsPage.category.nasalCare.desc": "Products to optimize nasal airflow and support healthy breathing patterns.",
  "productsPage.category.oralCare": "Oral Care",
  "productsPage.category.oralCare.desc": "Essential tools for maintaining oral health and supporting correct jaw alignment.",
  "productsPage.category.sleepCare": "Sleep & Noise Control",
  "productsPage.category.sleepCare.desc": "Comfortable solutions for better sleep quality and peaceful rest environments.",
  "productsPage.exploreCategory": "Explore Category",
  "productsPage.philosophy.title": "Our Product Philosophy",
  "productsPage.philosophy.desc1": "Every DR. MAGICAL product is developed with the same core principle: supporting the body's natural processes rather than forcing change.",
  "productsPage.philosophy.desc2": "We focus on comfort, discretion, and long-term usability — creating solutions that effortlessly become part of daily life.",
  "productsPage.principles.title": "Design Principles",
  "productsPage.principles.medical": "Medical-Grade Materials",
  "productsPage.principles.medical.desc": "Only the highest quality, skin-friendly materials that meet strict medical standards.",
  "productsPage.principles.comfort": "Comfort First",
  "productsPage.principles.comfort.desc": "Designed for extended wear without discomfort or awareness.",
  "productsPage.principles.discreet": "Discreet Design",
  "productsPage.principles.discreet.desc": "Invisible when worn, allowing you to maintain your daily routine naturally.",
  "productsPage.cta.title": "Ready to Get Started?",
  "productsPage.cta.desc": "Discover where to purchase DR. MAGICAL products through our official channels.",
  "productsPage.cta.button": "Where to Buy",

  // Brand Philosophy Page
  "philosophyPage.label": "(Philosophy)",
  "philosophyPage.title": "Body Aesthetics",
  "philosophyPage.title2": "Beyond Appearance",
  "philosophyPage.intro": "At DR. MAGICAL, we believe that true body aesthetics is not about aggressive transformation, but about understanding and respecting the body's natural structure, posture, and balance.",
  "philosophyPage.core.title": "Structure, Posture",
  "philosophyPage.core.title2": "and Daily Habits",
  "philosophyPage.core.desc1": "The foundation of body aesthetics lies not in superficial changes, but in structural alignment, postural quality, and the consistency of daily habits.",
  "philosophyPage.core.desc2": "We focus on non-invasive, physical correction methods that work with the body's natural mechanisms and support long-term balance.",
  "philosophyPage.core.desc3": "This approach respects the body's wisdom and allows health and form to develop naturally over time.",
  "philosophyPage.principles.title": "Our Three Core Principles",
  "philosophyPage.principles.1.title": "Understand Before Intervening",
  "philosophyPage.principles.1.desc": "Before any correction, we prioritize understanding the body's current state, its structural relationships, and the root causes of imbalances.",
  "philosophyPage.principles.2.title": "Gentle Guidance, Not Force",
  "philosophyPage.principles.2.desc": "Our products provide gentle, consistent guidance that encourages the body to realign naturally. We avoid aggressive methods.",
  "philosophyPage.principles.3.title": "Long-Term Companionship",
  "philosophyPage.principles.3.desc": "True change takes time. We design for daily use over months and years.",
  "philosophyPage.alignment.title": "Body Alignment ≠ Body Shape",
  "philosophyPage.alignment.desc1": "We're not about achieving a specific \"look\" or conforming to aesthetic standards.",
  "philosophyPage.alignment.desc2": "Instead, we focus on the body's structural integrity — how it stands, moves, breathes, and functions in daily life.",
  "philosophyPage.medical.title": "A Medical Perspective",
  "philosophyPage.medical.title2": "on Body Aesthetics",
  "philosophyPage.medical.desc1": "Founded by a German physician, DR. MAGICAL brings clinical rigor and scientific understanding to the field of body alignment.",
  "philosophyPage.medical.desc2": "We view the body as an integrated system where posture affects breathing, breathing affects sleep, and sleep affects overall health.",
  "philosophyPage.closing.title": "Respect. Balance. Time.",
  "philosophyPage.closing.desc": "These three words guide everything we create. We respect the body's intelligence, support its natural balance, and commit to being there for the long term.",

  // Where to Buy Page
  "buyPage.title": "Where to Buy",
  "buyPage.subtitle": "Purchase authentic DR. MAGICAL products through our official channels",
  "buyPage.retailers.title": "Official Retail Partners",
  "buyPage.retailers.tmall": "Tmall Global",
  "buyPage.retailers.tmall.desc": "Official flagship store with complete product range",
  "buyPage.retailers.alibaba": "Alibaba Health Pharmacy",
  "buyPage.retailers.alibaba.desc": "Verified platform for medical and health products",
  "buyPage.retailers.jd": "JD Supermarket",
  "buyPage.retailers.jd.desc": "Fast delivery with quality guarantee",
  "buyPage.retailers.tmallSuper": "Tmall Supermarket",
  "buyPage.retailers.tmallSuper.desc": "Convenient shopping with daily essentials",
  "buyPage.retailers.visit": "Visit Shop",
  "buyPage.why.title": "Why Buy Through Official Channels",
  "buyPage.why.authentic": "Authenticity Guaranteed",
  "buyPage.why.authentic.desc": "Every product is genuine, imported through official channels with complete compliance documentation.",
  "buyPage.why.support": "Brand Support",
  "buyPage.why.support.desc": "Direct customer service and support from DR. MAGICAL for all your questions and needs.",
  "buyPage.why.quality": "Quality Assurance",
  "buyPage.why.quality.desc": "Products meet all safety standards with proper quality control and warranty coverage.",
  "buyPage.international.title": "International Customers",
  "buyPage.international.desc": "DR. MAGICAL currently focuses on the Chinese market through our official partners. For international inquiries, please contact us directly.",
  "buyPage.international.button": "Contact Us",
  "buyPage.warning.title": "Important Notice",
  "buyPage.warning.desc": "DR. MAGICAL products are only available through the official channels listed on this page. We cannot guarantee the authenticity or safety of products purchased through unauthorized sellers.",

  // Contact Page
  "contactPage.title": "Contact Us",
  "contactPage.subtitle": "We're here to answer your questions and support you on your journey",
  "contactPage.form.title": "Send Us a Message",
  "contactPage.form.name": "Name",
  "contactPage.form.email": "Email",
  "contactPage.form.subject": "Subject",
  "contactPage.form.message": "Message",
  "contactPage.form.maxChars": "Maximum 500 characters",
  "contactPage.form.submit": "Send Message",
  "contactPage.form.submitting": "Sending...",
  "contactPage.form.success": "Thank you for your message. We will get back to you soon.",
  "contactPage.form.error": "Something went wrong. Please try again.",
  "contactPage.info.title": "Contact Information",
  "contactPage.info.general": "General Inquiries",
  "contactPage.info.email": "Email",
  "contactPage.info.phone": "Phone",
  "contactPage.info.headquarters": "Headquarters",
  "contactPage.info.address": "Address",
  "contactPage.info.addressValue": "Medical Innovation Center",
  "contactPage.info.hours": "Business Hours",
  "contactPage.info.hoursLabel": "Monday - Friday",
  "contactPage.info.hoursValue": "9:00 AM - 6:00 PM (CET)",
  "contactPage.info.follow": "Follow Us",
  "contactPage.faq.title": "Frequently Asked Questions",
  "contactPage.faq.q1": "Where can I buy DR. MAGICAL products?",
  "contactPage.faq.a1": "Our products are available through official channels including Tmall Global, Alibaba Health Pharmacy, JD Supermarket, and Tmall Supermarket.",
  "contactPage.faq.q2": "Are your products suitable for long-term use?",
  "contactPage.faq.a2": "Yes, all DR. MAGICAL products are designed for consistent, long-term use. They are made from medical-grade materials.",
  "contactPage.faq.q3": "Do you ship internationally?",
  "contactPage.faq.a3": "Currently, we focus on the Chinese market through our official retail partners. For international inquiries, please contact us directly.",
  "contactPage.faq.q4": "How can I verify product authenticity?",
  "contactPage.faq.a4": "Only purchase through our official channels. All authentic products come with proper packaging and documentation.",

  // Journal Page
  "journalPage.title": "Journal",
  "journalPage.subtitle": "Insights on body alignment, health, and wellness",
  "journalPage.readArticle": "Read Article",
  "journalPage.recentArticles": "Recent Articles",
  "journalPage.readMore": "Read More →",
  "journalPage.exploreTopics": "Explore by Topic",
  "journalPage.topics.alignment": "Body Alignment",
  "journalPage.topics.breathing": "Breathing Health",
  "journalPage.topics.wellness": "Daily Wellness",
  "journalPage.topics.research": "Medical Research",
  "journalPage.article1.title": "Understanding Body Alignment: A Medical Perspective",
  "journalPage.article1.excerpt": "Exploring the relationship between posture, breathing, and overall health from a medical science perspective.",
  "journalPage.article1.category": "Body Alignment",
  "journalPage.article1.date": "December 15, 2024",
  "journalPage.article2.title": "Mouth Breathing and Modern Lifestyle",
  "journalPage.article2.excerpt": "How contemporary habits affect breathing patterns and what we can do to support natural nasal breathing.",
  "journalPage.article2.category": "Breathing Health",
  "journalPage.article2.date": "December 10, 2024",
  "journalPage.article3.title": "Posture, Sleep, and Daily Habits",
  "journalPage.article3.excerpt": "The interconnected relationship between how we sit, stand, sleep, and our long-term health outcomes.",
  "journalPage.article3.category": "Daily Wellness",
  "journalPage.article3.date": "December 5, 2024",
  "journalPage.article4.title": "The Science of Non-Invasive Body Support",
  "journalPage.article4.excerpt": "Why gentle, consistent support often achieves better long-term results than aggressive interventions.",
  "journalPage.article4.category": "Medical Research",
  "journalPage.article4.date": "November 28, 2024",
  "journalPage.article5.title": "German Engineering Meets Medical Science",
  "journalPage.article5.excerpt": "How precision manufacturing and medical knowledge come together to create effective health products.",
  "journalPage.article5.category": "Design & Innovation",
  "journalPage.article5.date": "November 20, 2024",

  // Customer Stories Page
  "storiesPage.label": "(Customer Voices)",
  "storiesPage.title": "Real Stories,",
  "storiesPage.title2": "Real Changes",
  "storiesPage.subtitle": "Discover how DR. MAGICAL has positively impacted our customers' lives. Each story is a testament to the power of gentle, non-invasive body care.",
  "storiesPage.stats.satisfaction": "Customer Satisfaction",
  "storiesPage.stats.customers": "Satisfied Customers",
  "storiesPage.stats.rating": "Average Rating",
  "storiesPage.stats.recommendation": "Recommendation Rate",
  "storiesPage.featured.title": "Featured Success Stories",
  "storiesPage.featured.subtitle": "In-depth insights into our customers' experiences",
  "storiesPage.all.title": "All Customer Stories",
  "storiesPage.all.subtitle": "Filter by product category",
  "storiesPage.filter.all": "All",
  "storiesPage.filter.mouth": "Mouth Breathing",
  "storiesPage.filter.nasal": "Nasal Support",
  "storiesPage.filter.sleep": "Sleep Management",
  "storiesPage.reviews.title": "What Our Customers Say",
  "storiesPage.reviews.subtitle": "Short reviews from verified buyers",
  "storiesPage.cta.title": "Ready for Your Own Success Story?",
  "storiesPage.cta.subtitle": "Discover our products and begin your journey to better sleep and wellness.",
  "storiesPage.cta.products": "Discover Products",
  "storiesPage.cta.contact": "Get in Touch",
  "storiesPage.successStory": "Success Story",
  "storiesPage.usage": "Usage",
  "storiesPage.readFull": "Read Full Story",
  "storiesPage.showLess": "Show Less",
  "storiesPage.readStory": "Read Story",
  "storiesPage.close": "Close",
  "storiesPage.product": "Product",

  // German Medical Origin Page
  "originPage.label": "(Origin Story)",
  "originPage.title": "Medical Insight,",
  "originPage.title2": "German Precision",
  "originPage.intro": "Founded in 2018 by a German physician, DR. MAGICAL emerged from years of research on the relationship between body structure, posture, and health.",
  "originPage.founder.title": "From Clinical Research",
  "originPage.founder.title2": "to Daily Solutions",
  "originPage.founder.desc1": "The founder, a practicing physician in Germany, observed for years how modern lifestyle habits — prolonged sitting, screen time, mouth breathing — caused widespread postural and structural problems.",
  "originPage.founder.desc2": "These issues were not addressed by traditional medicine, which focused on treating symptoms rather than supporting the body's natural alignment.",
  "originPage.founder.desc3": "DR. MAGICAL was born from the belief that medical knowledge can be translated into practical, wearable solutions for everyday life.",
  "originPage.tradition.title": "Rooted in German Medical Tradition",
  "originPage.tradition.evidence": "Evidence-Based Approach",
  "originPage.tradition.evidence.desc": "Every product is developed based on anatomical understanding, clinical observation, and rigorous testing.",
  "originPage.tradition.precision": "Engineering Precision",
  "originPage.tradition.precision.desc": "German engineering discipline ensures every detail meets the highest quality and functionality standards.",
  "originPage.tradition.safety": "Safety First",
  "originPage.tradition.safety.desc": "All products undergo thorough safety testing and comply with medical device standards.",
  "originPage.tradition.longterm": "Long-Term Thinking",
  "originPage.tradition.longterm.desc": "We design for durability and sustainable use, not disposable consumption.",
  "originPage.research.title": "Research Areas",
  "originPage.research.title2": "and Expertise",
  "originPage.research.structure": "Body Structure & Posture",
  "originPage.research.structure.desc": "Understanding how skeletal alignment, muscle tension, and daily habits interact.",
  "originPage.research.breathing": "Breathing Patterns",
  "originPage.research.breathing.desc": "Researching the effects of mouth breathing versus nasal breathing on facial development and sleep quality.",
  "originPage.research.sleep": "Sleep & Recovery",
  "originPage.research.sleep.desc": "Exploring how body position, breathing, and environmental factors affect sleep quality.",
  "originPage.research.materials": "Material Science",
  "originPage.research.materials.desc": "Developing medical-grade materials for long-term daily use.",
  "originPage.manufacturing.title": "Quality & Manufacturing",
  "originPage.manufacturing.desc": "All DR. MAGICAL products are manufactured in facilities that meet European medical device standards.",
  "originPage.manufacturing.quality": "Medical Grade",
  "originPage.manufacturing.certified": "Certified",
  "originPage.manufacturing.years": "Years of Research",
  "originPage.global.title": "From Germany to the World",
  "originPage.global.desc1": "Since entering the Chinese market in 2020, DR. MAGICAL has partnered with leading e-commerce platforms including Tmall Global, Alibaba Health Pharmacy, JD Supermarket, and Tmall Supermarket.",
  "originPage.global.desc2": "Our vision is to become a trusted part of premium family health management worldwide.",
  "originPage.closing.title": "Medical Knowledge,",
  "originPage.closing.title2": "Daily Application",
  "originPage.closing.desc": "This is the essence of DR. MAGICAL — translating clinical insights into practical solutions that support the body's natural balance every day.",

  // Science & Design Page
  "sciencePage.title": "Science & Design",
  "sciencePage.subtitle": "Where medical knowledge meets precision engineering",
  "sciencePage.philosophy.title": "Our Design Philosophy",
  "sciencePage.philosophy.desc1": "Every DR. MAGICAL product begins with a medical question: How can we support the body's natural processes without intervention or force?",
  "sciencePage.philosophy.desc2": "From this foundation, we apply German engineering principles — precision, durability, and functional elegance — to create solutions that work seamlessly with daily life.",
  "sciencePage.philosophy.desc3": "The result is products that feel invisible when worn, yet provide consistent, gentle support over months and years.",
  "sciencePage.principles.title": "Core Design Principles",
  "sciencePage.principles.medical.title": "Medical Foundation",
  "sciencePage.principles.medical.desc": "Every design decision is grounded in medical research and clinical understanding of body mechanics.",
  "sciencePage.principles.precision.title": "Precision Engineering",
  "sciencePage.principles.precision.desc": "German manufacturing standards ensure consistent quality and exact specifications in every product.",
  "sciencePage.principles.human.title": "Human-Centered",
  "sciencePage.principles.human.desc": "Comfort and ease of use guide every iteration, ensuring products integrate naturally into daily life.",
  "sciencePage.materials.title": "Material Selection",
  "sciencePage.materials.medical.title": "Medical-Grade Standards",
  "sciencePage.materials.medical.desc1": "All materials meet strict medical device standards for biocompatibility, safety, and hypoallergenic properties.",
  "sciencePage.materials.medical.desc2": "We prioritize materials with proven track records in medical applications, ensuring safety for long-term skin contact.",
  "sciencePage.materials.comfort.title": "Comfort & Durability",
  "sciencePage.materials.comfort.desc1": "Materials are selected not just for safety, but for their ability to maintain comfort and performance over extended use.",
  "sciencePage.materials.comfort.desc2": "Breathability, flexibility, and resilience are carefully balanced to create products that feel natural.",
  "sciencePage.materials.environment.title": "Environmental Consciousness",
  "sciencePage.materials.environment.desc1": "Where possible, we choose materials with lower environmental impact without compromising medical standards.",
  "sciencePage.materials.environment.desc2": "Durability itself is an environmental choice — products that last longer reduce waste and resource consumption.",
  "sciencePage.materials.testing.title": "Continuous Testing",
  "sciencePage.materials.testing.desc1": "Materials undergo rigorous testing for skin compatibility, wear resistance, and performance consistency.",
  "sciencePage.materials.testing.desc2": "We maintain strict quality controls throughout the supply chain to ensure every product meets our standards.",
  "sciencePage.process.title": "Development Process",
  "sciencePage.process.step1.title": "Medical Research",
  "sciencePage.process.step1.desc": "We begin by identifying a specific body alignment challenge through clinical observation and literature review. This forms the scientific foundation for the product.",
  "sciencePage.process.step2.title": "Concept Development",
  "sciencePage.process.step2.desc": "Our design team translates medical requirements into physical concepts, exploring materials, structures, and mechanisms that can provide the needed support.",
  "sciencePage.process.step3.title": "Prototyping & Testing",
  "sciencePage.process.step3.desc": "Multiple prototypes are created and tested for comfort, effectiveness, and durability. User feedback guides iterative improvements until the design meets all requirements.",
  "sciencePage.process.step4.title": "Manufacturing Optimization",
  "sciencePage.process.step4.desc": "Production processes are optimized to ensure consistent quality at scale, with rigorous quality controls at every stage.",
  "sciencePage.process.step5.title": "Continuous Improvement",
  "sciencePage.process.step5.desc": "Even after launch, we collect user feedback and monitor performance to identify opportunities for improvement in future versions.",
  "sciencePage.detail.title": "Attention to Detail",
  "sciencePage.detail.desc1": "The German design tradition emphasizes that every detail matters. From the radius of a curve to the texture of a surface, every element is considered for its impact on function and comfort.",
  "sciencePage.detail.desc2": "This meticulous approach means our products often appear simple, but that simplicity is the result of countless refinements to eliminate everything unnecessary.",
  "sciencePage.detail.desc3": "The goal is products that feel intuitive to use, require no learning curve, and integrate seamlessly into daily routines.",
  "sciencePage.cta.title": "Experience the Difference",
  "sciencePage.cta.desc": "Discover how medical science and precision design come together in products that support your body's natural balance.",
  "sciencePage.cta.button": "Explore Products",
};

export default common;
